export default __webpack_public_path__ + "static/media/what_is_ippis.b0da3788.png";